import {
	Avatar,
	Box,
	IconButton,
	Typography,
}
from '@mui/material';

import BlockFactory from './BlockFactory';

//import CloseIcon from '@mui/icons-material/Close';
import DeleteBlockIcon from 'icons/drawable/ic_16_close.svg';

function BlockEditHeader({ blockName, iconChar, iconColor, onDelete }) {

	const blockNameForDisp = BlockFactory.getDisplayBlockName(blockName);

	function handleDelete() {
		if (onDelete) onDelete(blockName);
	}

	function getDeleteButton() {
		if (onDelete) {
			const iconSize = `${20/360 * 100}vw`;

			return (
				<Box justifyContent='flex-end' alignItems='center' sx={{height:'100%'}}>
					<IconButton
						sx={{
							width: iconSize,
							height: iconSize,
						}}
						onClick={e => handleDelete()}
					>
						<img
							src={DeleteBlockIcon}
							alt='delete block icon'
							style={{
								width: `${16/360 * 100}vw`,
								height: `${16/360 * 100}vw`,
							}}
						/>
					</IconButton>
				</Box>
			);
		}
		else {
			return null;
			//return (
			//	<Box justifyContent='flex-end' alignItems='center'/>
			//);
		}
	}

	const commonLen = `${(20 / 360) * 100}vw`;

	return (
		<Box
			display='flex'
			flexDirection='row'
			justifyContent='space-between'
			alignItems='center'
			sx={{
				width: '100%',
				height: commonLen,
				marginTop: `${30/360 * 100}vw`,
				marginBottom: commonLen,
			}}
		>
			<Box
				display='flex'
				flexDirection='row'
				justifyContent='flex-start'
				alignItems='center'
			>
				<Avatar
					sx={{
						width: commonLen,
						height: commonLen,
						bgcolor: iconColor,
						marginRight: `${10/360 * 100}vw`,
					}}
				>
                    <Typography
                        fontFamily='Montserrat-ExtraBold'
                        fontSize={`${14/360 * 100}vw`}
                        color='#ffffff'
                    >
						{iconChar}
					</Typography>
				</Avatar>
				<Typography
					fontFamily='노토산스 Bold'
					fontSize={`${16/360 * 100}vw`}
					color='#171717'
				>
					{blockNameForDisp}
				</Typography>
			</Box>

			{getDeleteButton()}
		</Box>
	);
}

export default BlockEditHeader;
